<template>
  <div class="text-body-1 bordered rounded pa-1 bg-grey_1">
    <v-icon icon="mdi-gesture-tap"></v-icon> Vous avez déjà {{ account_wording[0] }} Sportips ? <a
      class="text-primary-dark" @click="showDialog = true">Connectez-vous</a> afin de retrouver rapidement vos
    informations (identité, documents,
    licences) et celles de vos
    proches.

    <v-dialog v-model="showDialog" width="500" max-width="100%" scroll-strategy="none">
      <v-card>
        <v-card-text>
          <LoginForm></LoginForm>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" block @click="showDialog = false">Fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import LoginForm from "../Authentification/LoginForm.vue";

export default {
  components: { LoginForm },
  data() {
    return {
      showDialog: false,
    };
  },
  computed: {
    ...mapStores(useMainStore),
    account_wording() {
      const is_bicentenaire = this.mainStore.module.is_BICENTENAIRE26_module;
      if (is_bicentenaire) {
        return ["un espace personnel", "espace personnel"];
      } else {
        return ["un compte", "compte"];
      }
    }
  },
  watch: {
    "mainStore.authUser.isLogged": function () {
      this.showDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
a:hover {
  cursor: pointer;
}
</style>